(function () {
  var root = document.getElementById('shabbat-checkout-root');
  if (!root) return;

  var statusUrl = root.dataset.statusUrl;
  var captureUrl = root.dataset.captureUrl;
  if (!statusUrl || !captureUrl) {
    console.warn('[Shabbat Checkout Lock] Status/capture API URL not configured in theme editor.');
    return;
  }

  var STATUS_CACHE_MS = 2 * 60 * 1000; // re-check every 2 minutes
  var cachedStatus = null;
  var cachedAt = 0;

  // Selectors covering standard Shopify 2.0 checkout entry points
  // (cart page button, cart drawer button, dynamic checkout links).
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    '[data-checkout-button]'
  ].join(',');

  // Express checkout buttons (Shop Pay, Apple Pay, Google Pay, PayPal) cannot
  // be intercepted with preventDefault — they open a native payment sheet before
  // the click event bubbles. Instead we hide them via CSS when checkout is blocked.
  var EXPRESS_HIDE_ID = 'shabbat-express-hide';
  var EXPRESS_CHECKOUT_CSS =
    '.shopify-payment-button,' +
    '[data-shopify="payment-button"],' +
    '.additional-checkout-buttons,' +
    '.cart__dynamic-checkout-buttons,' +
    '.dynamic-checkout-cart { display: none !important; }';

  function hideExpressCheckout() {
    if (document.getElementById(EXPRESS_HIDE_ID)) return;
    var s = document.createElement('style');
    s.id = EXPRESS_HIDE_ID;
    s.textContent = EXPRESS_CHECKOUT_CSS;
    document.head.appendChild(s);
  }

  function showExpressCheckout() {
    var s = document.getElementById(EXPRESS_HIDE_ID);
    if (s) s.remove();
  }

  function fetchStatus() {
    var now = Date.now();
    if (cachedStatus && now - cachedAt < STATUS_CACHE_MS) {
      return Promise.resolve(cachedStatus);
    }
    return fetch(statusUrl, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cachedStatus = data;
        cachedAt = now;
        if (data.blocked) { hideExpressCheckout(); } else { showExpressCheckout(); }
        return data;
      })
      .catch(function () {
        // Fail open: if the status API is unreachable, do not block checkout.
        showExpressCheckout();
        return { blocked: false };
      });
  }

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'shabbat-lock-overlay';
    overlay.innerHTML =
      '<div class="shabbat-lock-modal" role="dialog" aria-modal="true" aria-labelledby="shabbat-lock-heading">' +
        '<button type="button" class="shabbat-lock-close" aria-label="Close">&times;</button>' +
        '<h2 id="shabbat-lock-heading">' + root.dataset.heading + '</h2>' +
        '<p class="shabbat-lock-message">' + root.dataset.message + '</p>' +
        '<form class="shabbat-lock-form">' +
          '<input type="email" name="email" required placeholder="you@example.com" aria-label="Email address">' +
          '<button type="submit">' + root.dataset.buttonLabel + '</button>' +
        '</form>' +
        '<p class="shabbat-lock-success" hidden>' + root.dataset.successMessage + '</p>' +
        '<p class="shabbat-lock-error" hidden>Something went wrong. Please try again.</p>' +
      '</div>';
    document.body.appendChild(overlay);

    function close() {
      overlay.remove();
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.shabbat-lock-close').addEventListener('click', close);

    var form = overlay.querySelector('.shabbat-lock-form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return fetch(captureUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email,
              cart_token: cart.token,
              cart: cart
            })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('capture failed');
          form.hidden = true;
          overlay.querySelector('.shabbat-lock-success').hidden = false;
        })
        .catch(function () {
          submitBtn.disabled = false;
          overlay.querySelector('.shabbat-lock-error').hidden = false;
        });
    });
  }

  // We only ever intervene (preventDefault) when we're CERTAIN checkout must
  // be blocked. Otherwise we never touch the event, so other scripts/apps
  // with their own listeners on the same button (e.g. lb-checkout-listener)
  // keep working exactly as if this script weren't installed.
  function onCheckoutClick(e) {
    var target = e.target.closest(CHECKOUT_SELECTOR);
    if (!target) return;

    var now = Date.now();
    var haveFreshCache = cachedStatus && now - cachedAt < STATUS_CACHE_MS;

    if (haveFreshCache) {
      if (cachedStatus.blocked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hideExpressCheckout();
        buildModal();
      }
      // Not blocked: do nothing at all, let the click proceed natively.
      return;
    }

    // No fresh cache (rare — cache is warmed on page load). Block briefly
    // while we check, since we can't know yet whether checkout is allowed.
    e.preventDefault();
    e.stopImmediatePropagation();
    target.classList.add('shabbat-lock-loading');

    fetchStatus().then(function (status) {
      target.classList.remove('shabbat-lock-loading');
      if (status && status.blocked) {
        buildModal();
      } else {
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    });
  }

  document.addEventListener('click', onCheckoutClick, true);

  // Warm the cache on load so the first click doesn't feel laggy.
  fetchStatus();
})();
